module.exports = __webpack_public_path__ + "static/media/grandTech.90522177.webp";